import { asTranslationKey } from '../common/translate-helpers/i18n-utils'
import { Appearance } from '../services/presence'

export const getAppearanceTranslationKey = (appearance: Appearance, forPresenceSelection: boolean) => {
  switch (appearance) {
    case Appearance.ONLINE:
      return asTranslationKey('Available')
    case Appearance.BUSY:
      return asTranslationKey('Busy')
    case Appearance.DO_NOT_DISTURB:
      return asTranslationKey('Do not disturb')
    case Appearance.AWAY:
      return asTranslationKey('Away')
    default:
      return forPresenceSelection ? asTranslationKey('Appear offline') : asTranslationKey('Offline')
  }
}
